import React, { useEffect, useState, useContext } from "react";
import { Icon } from "@iconify/react";
import {
  AddCentre,
  getCentres,
  useGetCentres,
  useGetPeoples,
  addMember,
  removeMember,
  useGetSpecificCenter,
} from "../../api/settings";
import AddUpdateCentres from "../../components/AddUpdateCenters";
import Avatar from "@mui/material/Avatar";
import Swal from "sweetalert2";
import { toast } from "sonner";
import AddMember from "../../components/AddMember";
import { AuthContext } from "../../context/AuthContextProvider";
import { BlankPreview } from "../../components/BlankPreview";
import nopreview from "../../assets/images/others/no-preview.png";
import { RequireAuth } from "../../RequireAuth.jsx";
import { set, sortBy } from "lodash";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { id, is } from "date-fns/locale";
import SelectCenter from "../../components/SelectCenter.jsx";
import FilterSelect from "../../components/FilterSelect.jsx";
import { ANALYTICS_EVENTS, logAnalyticsEvent } from "../../analytics";
import { se } from "date-fns/locale";
import spokeIcon from "../../assets/icons/Spoke.svg";
import {
  Autocomplete,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  ListItemText,
  OutlinedInput,
  Menu,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  InputAdornment,
  Grid,
} from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import CenterDetails from "../../components/Reusables/LayoutControls/CentreDetails.jsx";
const data = [
  "Eugenia",
  "Bryan",
  "Linda",
  "Nancy",
  "Lloyd",
  "Alice",
  "Julia",
  "Albert",
].map((item) => ({ label: item, value: item }));

const ManageCentres = () => {
  const { centreId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { center, isLoading: isCenterLoading } = useGetSpecificCenter(centreId);

  const [members, setMembers] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(center);
  const { user } = useContext(AuthContext);
  // Migrated businesses don't get to add more spokes/members from the UI -
  // userType stays plain "b2b", migration is a separate flag.
  const isMigratedUser = user?.userType === "b2b" && user?.migration === true;
  const [addNewMember, setAddNewMember] = useState(false);

  // const [args, setArgs] = useState({
  //   centerIds: [center?.id],
  // });
  const [args, setArgs] = useState(null);
  useEffect(() => {
    if (center?.id || center?._id) {
      setArgs({
        centerIds: [center.id || center._id],
      });
    }
  }, [center]);

  const { peoples, isLoading } = useGetPeoples(args);

  useEffect(() => {
    setMembers(peoples);
  }, [peoples]);

  // Sync editCenter with URL hash so browser back/forward toggles UI
  useEffect(() => {
    const applyHash = () => {
      setEditCenter(window.location.hash === "#edit");
    };

    // set initial state from current location.hash (handles page reload with #edit)
    applyHash();

    // listen to user pressing browser back/forward or manual hash changes
    window.addEventListener("hashchange", applyHash);

    return () => {
      window.removeEventListener("hashchange", applyHash);
    };
  }, []);

  const closeEdit = () => {
    // remove hash without adding another history entry
    const baseUrl = location.pathname;
    window.history.replaceState(null, "", baseUrl);

    setEditCenter(false);
    // optionally setSelectedCenter(null) or whatever cleanup you need
  };


  const handleAddMember = async (data) => {
    if (!data) {
      setAddNewMember(false);
      return;
    }

    try {
      const centerIds = [center.id];
      data.centerIds = centerIds;

      const response = await addMember(data);

      if (response.success) {
        const newMember = response.data?.[0];
        logAnalyticsEvent(ANALYTICS_EVENTS.MEMBER_ADDED, {
          added_user_id: newMember?._id,
          assigned_role: data?.role,
          assigned_centre_id: center.id,
        });
        setMembers((prev) => [...prev, newMember]); // Fix: Add new member properly
        toast.success("Member added successfully");
      } else {
        toast.error(response.message || "Failed to add member");
      }
    } catch (e) {
      console.error("Add member error:", e);
      toast.error("Something went wrong while adding the member.");
    } finally {
      setAddNewMember(false);
    }
  };

  const handleRemoveMember = async (member_id, index) => {
    //remove for member array

    const newMembers = members.filter((member, i) => i !== index);
    setMembers(newMembers);

    try {
      const data = {
        userId: member_id,
        centerIds: [center?.id],
      };
      const response = await removeMember(data);
      if (response.success) {
        toast.success("Member removed successfully");
      } else {
        toast.error(response.message);
      }
    } catch (e) { }
  };

  const renderToggle = (props) => <i {...props} className="fa fa-ellipsis-v" />;

  const [editCenter, setEditCenter] = useState(false);

  const [selectedMember, setSelectedMember] = useState(null);

  const handleEditCenter = () => {
    // ensure center.members is kept
    center.members = members;

    // push a history entry that adds #edit
    const newUrl = `${location.pathname}#edit`;
    window.history.pushState(null, "", newUrl);

    // set the selected center correctly and open edit UI
    setSelectedCenter(center);
    setEditCenter(true);
  };


  // Inside your component (before return)
  const invitedMembers = members.filter((m) => m?.user?.status === "invited");
  const activeMembers = members.filter((m) => m?.user?.status !== "invited");

  return (
    <>
      <div className="main-wrappers">
        <div
          className="page-wrapper"
          style={{
            maxHeight: "99vh",
            overflowY: "auto",
            paddingBottom: "10px",
            paddingTop: "75px",
            fontFamily: "Figtree",
            backgroundColor: "var(--app-bg)",
          }}
        >
          <div className="content">
            <Breadcrumbs aria-label="breadcrumb" separator="›">
              {/* Settings - clickable */}
              <Link
                component={RouterLink}
                to="/settings/centres"
                underline="hover"
                color="inherit"
              >
                Settings
              </Link>

              {/* hierarchy[1] if present - clickable */}
              {center?.hierarchy?.[1]?.name && (
                <Link
                  component={RouterLink}
                  to={
                    center.hierarchy[1].id
                      ? `/settings/centres/${center.hierarchy[1].id}`
                      : `/settings/centres?levelName=${encodeURIComponent(center.hierarchy[1].name)}${center.hierarchy[1].type ? `&type=${encodeURIComponent(center.hierarchy[1].type)}` : ""
                      }`
                  }
                  underline="hover"
                  color="inherit"
                  fontFamily="Figtree"
                >
                  {center.hierarchy[1].name}
                </Link>
              )}

              {/* center name only if different from hierarchy[1] */}
              {center?.name && center?.hierarchy?.[1]?.name !== center.name && (
                <Typography color="text.primary" sx={{ fontFamily: "Figtree" }}>{center.name}</Typography>
              )}
            </Breadcrumbs>
            {" "}
            {editCenter ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <h5
                      style={{ cursor: "pointer" }}
                      onClick={closeEdit}
                    >
                      <strong>
                        <i className="fa fa-angle-left"></i>&nbsp; Edit Center
                      </strong>
                    </h5>
                    <AddUpdateCentres
                      type="edit"
                      item={center}
                      setSelectedCenter={setSelectedCenter}
                    // handleManageCenters={handleManageCenters}
                    />
                  </div>
                </div>
              </>
            ) : selectedMember == null ? (
              <div className="row">
                <div className="col-md-12 ">
                  <h5
                    onClick={() => {
                      // handleManageCenters(true);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <strong>{center?.name}</strong>
                  </h5>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "16px", fontFamily: "Figtree" }}
                  >
                    <CenterDetails
                      center={center}
                      onEdit={handleEditCenter}
                    />
                  </div>

                  {center?.centerType === "hub" && !isMigratedUser && (
                    <div className="card2 pt-20">
                      <div className="row ">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontFamily: "Figtree",
                          }}
                        >
                          <h5>
                            <strong>Spoke Centres</strong>
                          </h5>
                          <RequireAuth role={["b2b"]}>
                            <Link
                              component={RouterLink}
                              to={`/add-centre?id=${center?.id || center?._id
                                }&type=spoke`}
                              className="dd-login"
                            >
                              <Icon
                                icon="material-symbols:add"
                                height="20px"
                                width="20px"
                              />{" "}
                              <strong>Add New Spoke</strong>
                            </Link>
                          </RequireAuth>
                        </div>
                      </div>

                      {
                        center?.spokeCenters?.length > 0 ? (
                          <TableContainer className="app-table-card"
                            component={Paper}
                            elevation={0}
                            sx={{
                              backgroundColor: "transparent",
                              boxShadow: "none",
                              mt: 1,
                            }}
                          >
                            <Table
                              size="small"
                              sx={{
                                borderCollapse: "separate",
                                borderSpacing: "0 10px", // 👈 adds vertical spacing between rows
                                "& th": {
                                  borderBottom: "none",
                                  color: "#A3A3A3",
                                  fontWeight: 800,
                                },
                                "& td": {
                                  borderBottom: "none",
                                  verticalAlign: "middle",
                                  backgroundColor: "var(--app-surface-2)", // 👈 grey background for each row

                                },
                                fontFamily: "Figtree",
                              }}
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell>NAME</TableCell>
                                  <TableCell>CONTACT</TableCell>
                                  <TableCell>TYPE</TableCell>
                                  <TableCell>ADDRESS</TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {center?.spokeCenters.map((spoke, index) => (
                                  <TableRow
                                    key={spoke._id || index}
                                    sx={{
                                      "&:hover": { backgroundColor: "var(--app-surface-2)" },
                                    }}
                                  >
                                    {/* NAME + LOGO */}
                                    <TableCell>
                                      <Box display="flex" alignItems="center" gap={1.5}>
                                        <Avatar
                                          variant="square"
                                          src={spoke.logo || undefined}
                                          sx={{
                                            width: 32,
                                            height: 32,
                                            bgcolor: "#f0f0f0",
                                            mr: 1,
                                          }}
                                        >
                                          {!spoke.logo && (
                                            <Box
                                              component="img"
                                              src={spokeIcon}
                                              alt="spoke-icon"
                                              sx={{ width: 25, height: 25 }}
                                            />
                                          )}
                                        </Avatar>

                                        <Typography
                                          variant="body2"
                                          onClick={() => {
                                            navigate(`/settings/centres/${spoke.id}`);
                                            const updatedSpoke = {
                                              ...spoke,
                                              hierarchy: [
                                                {
                                                  name: center?.hierarchy.find(
                                                    (h) => h.type === "org"
                                                  )?.name,
                                                },
                                                { name: center?.name, type: "hub" },
                                                { name: spoke?.name, type: "spoke" },
                                              ],
                                              isSpoke: true,
                                            };
                                            setSelectedCenter(updatedSpoke);
                                            setArgs({ centerIds: [spoke.id || spoke._id] });
                                          }}
                                          sx={{
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            color: "inherit",
                                            "&:hover": { color: "var(--app-text)" },
                                          }}
                                        >
                                          {spoke?.name}
                                        </Typography>
                                      </Box>
                                    </TableCell>

                                    {/* CONTACT */}
                                    <TableCell>
                                      <Typography variant="body2">
                                        {spoke.phone
                                          ? `${spoke.country_code ?? ""} ${spoke.phone}`
                                          : "--"}
                                      </Typography>
                                    </TableCell>

                                    {/* TYPE */}
                                    <TableCell>
                                      <Typography variant="body2">{spoke.type || "Spoke"}</Typography>
                                    </TableCell>

                                    {/* ADDRESS */}
                                    <TableCell>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {spoke?.address?.area || "--"},{" "}
                                        {spoke?.address?.city || "--"}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : (
                          <Typography variant="body2" color="text.secondary" mt={2}>
                            No Spoke Centres
                          </Typography>
                        )
                      }

                      {addNewMember && (
                        <div className="mt-3">
                          <AddMember
                            handleAddMember={handleAddMember}
                            type={"addcenter"}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {(!isMigratedUser &&
                    <div className="card2 pt-20">
                      <div className="row ">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontFamily: "Figtree",
                          }}
                        >
                          <h5>
                            <strong>Members</strong>
                          </h5>

                          <Link
                            component={RouterLink}
                            to={`/add-member?id=${center?.id || center?._id
                              }&type=${center?.hierarchy?.length
                                ? center.hierarchy[center.hierarchy.length - 1]
                                  .type
                                : "hub" // fallback if hierarchy missing
                              }`}
                            className="dd-login"
                          >
                            <Icon
                              icon="material-symbols:add"
                              height="20px"
                              width="20px"
                            />{" "}
                            <strong>Add New Members</strong>
                          </Link>
                        </div>
                      </div>

                      {members.length > 0 ? (
                        <TableContainer className="app-table-card"
                          component={Paper}
                          sx={{
                            maxHeight: "70vh",
                            overflowY: "auto",
                            border: "none",
                            boxShadow: "none",
                          }}
                        >
                          <Table
                            stickyHeader
                            sx={{
                              borderCollapse: "separate",
                              borderSpacing: "0 10px",
                              "& th": {
                                borderBottom: "none",
                                fontWeight: 600,
                                fontSize: "13px",
                                color: "#A3A3A3",
                                backgroundColor: "var(--app-surface)",
                                py: 2,
                              },
                              "& td": {
                                borderBottom: "none",
                                fontSize: "15px",
                                py: 1.5,
                                px: 2,
                                color: "var(--app-text)",
                                backgroundColor: "var(--app-surface-2)",
                              },
                              fontFamily: "Figtree",
                            }}
                          >
                            <TableHead>
                              <TableRow>
                                {[
                                  "NAME",
                                  "MOBILE NUMBER",
                                  "EMAIL",
                                  "ROLE",
                                  "DESIGNATION",
                                ].map((heading, idx) => (
                                  <TableCell key={idx}>
                                    <Typography
                                      component="h3"
                                      sx={{ fontSize: "13px", fontWeight: 800 }}
                                    >
                                      {heading}
                                    </Typography>
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {members.map((member, index) => (
                                <TableRow
                                  key={member._id || index}
                                  sx={{
                                    border: "none",
                                    borderRadius: "8px",
                                    "& > *:first-of-type": {
                                      borderTopLeftRadius: "8px",
                                      borderBottomLeftRadius: "8px",
                                    },
                                    "& > *:last-of-type": {
                                      borderTopRightRadius: "8px",
                                      borderBottomRightRadius: "8px",
                                    },
                                  }}
                                >
                                  {/* NAME + AVATAR */}
                                  <TableCell>
                                    <Box display="flex" alignItems="center">
                                      <Avatar
                                        src={member?.profileImage || undefined}
                                        sx={{ width: 30, height: 30 }}
                                      >
                                        {!member?.profileImage &&
                                          (member?.fullName
                                            ? member.fullName
                                              .split(" ")
                                              .map((n) => n[0])
                                              .join("")
                                              .substring(0, 2)
                                              .toUpperCase()
                                            : "N")}
                                      </Avatar>
                                      <Typography
                                        ml={1}
                                        sx={{
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                          whiteSpace: "nowrap",
                                        }}
                                        onClick={() => {
                                          window.scrollTo(0, 0);
                                          setSelectedMember(member);
                                        }}
                                      >
                                        {member?.fullName || "--"}
                                      </Typography>
                                    </Box>
                                  </TableCell>

                                  {/* MOBILE NUMBER */}
                                  <TableCell>
                                    {member?.phoneNo
                                      ? `${member?.countryCode ?? ""} ${member?.phoneNo
                                      }`
                                      : "-"}
                                  </TableCell>

                                  {/* EMAIL */}
                                  <TableCell>{member?.email || "--"}</TableCell>

                                  {/* ROLE */}
                                  <TableCell>
                                    {member?.displayRole || "--"}
                                  </TableCell>

                                  {/* DESIGNATION + STATUS */}
                                  <TableCell>
                                    <Box display="flex" alignItems="center">
                                      <Typography>
                                        {member?.designation || "--"}
                                      </Typography>
                                      {member?.userStatus === "invited" && (
                                        <Box
                                          component="span"
                                          sx={{
                                            ml: 1.5,
                                            fontSize: "12px",
                                            backgroundColor: "#FFF3E0",
                                            color: "#B26A00",
                                            px: 1.2,
                                            py: 0.3,
                                            borderRadius: "5px",
                                            fontWeight: 600,
                                          }}
                                        >
                                          Invited
                                        </Box>
                                      )}
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <BlankPreview
                          icon={nopreview}
                          title="No Members"
                          subtitle=""
                        />
                      )}



                      {addNewMember && (
                        <div className="mt-3">
                          <AddMember
                            handleAddMember={handleAddMember}
                            type={"addcenter"}
                          />
                        </div>
                      )}
                    </div>)}
                </div>
              </div>

            ) : (
              <div className="row">
                <div className="col-md-8 offset-md-2">
                  <h5
                    style={{
                      cursor: "pointer",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                    onClick={() => {
                      setSelectedMember(null);
                    }}
                  >
                    <strong>
                      {" "}
                      <i
                        className="fas fa-angle-left"
                        style={{ marginLeft: "10px" }}
                      ></i>{" "}
                      {"Member - " + selectedMember?.fullName ?? " "}
                    </strong>
                  </h5>

                  <div className="card2 pt-20" style={{ padding: "20px" }}>
                    <AddMember
                      handleAddMember={handleAddMember}
                      userId={selectedMember.user_id}
                      type={"view"}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageCentres;
